/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Section_RejectedInputs */

const en_jobs_section_rejected = /** @type {(inputs: Jobs_Section_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejected — reverted to original`)
};

const de_jobs_section_rejected = /** @type {(inputs: Jobs_Section_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgelehnt — auf Original zurückgesetzt`)
};

const fr_jobs_section_rejected = /** @type {(inputs: Jobs_Section_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejeté — retour à la version originale`)
};

const es_jobs_section_rejected = /** @type {(inputs: Jobs_Section_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazado — revertido al original`)
};

const it_jobs_section_rejected = /** @type {(inputs: Jobs_Section_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rifiutato — ripristinato l'originale`)
};

const nl_jobs_section_rejected = /** @type {(inputs: Jobs_Section_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgewezen — teruggezet naar origineel`)
};

const pl_jobs_section_rejected = /** @type {(inputs: Jobs_Section_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odrzucono — przywrócono oryginał`)
};

const fi_jobs_section_rejected = /** @type {(inputs: Jobs_Section_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hylätty — palautettu alkuperäiseen`)
};

const da_jobs_section_rejected = /** @type {(inputs: Jobs_Section_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afvist — vendt tilbage til original`)
};

const sv_jobs_section_rejected = /** @type {(inputs: Jobs_Section_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvisat — återställt till original`)
};

/**
* | output |
* | --- |
* | "Rejected — reverted to original" |
*
* @param {Jobs_Section_RejectedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_section_rejected = /** @type {((inputs?: Jobs_Section_RejectedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Section_RejectedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_section_rejected(inputs)
	if (locale === "fr") return fr_jobs_section_rejected(inputs)
	if (locale === "es") return es_jobs_section_rejected(inputs)
	if (locale === "it") return it_jobs_section_rejected(inputs)
	if (locale === "nl") return nl_jobs_section_rejected(inputs)
	if (locale === "pl") return pl_jobs_section_rejected(inputs)
	if (locale === "fi") return fi_jobs_section_rejected(inputs)
	if (locale === "da") return da_jobs_section_rejected(inputs)
	if (locale === "sv") return sv_jobs_section_rejected(inputs)
	return en_jobs_section_rejected(inputs)
});